import { useMemo } from 'react';

import type { NewUserQuizStatus } from '@/shared/api/newUserQuiz';

import { getNewUserQuizLocalization } from '../lib/i18n';
import { useNewUserQuizFlow } from '../model/useNewUserQuizFlow';
import { NewUserQuizQuestions } from './NewUserQuizQuestions';

type NewUserQuizProps = {
  userId: string;
  onBypass: () => void;
  onCompleted: (status: NewUserQuizStatus) => void;
  onDismiss: () => void;
};

export const NewUserQuiz = ({ userId, onBypass, onCompleted, onDismiss }: NewUserQuizProps) => {
  const flow = useNewUserQuizFlow(userId, onBypass, onCompleted, onDismiss);
  const localization = useMemo(() => getNewUserQuizLocalization(), []);

  return (
    <NewUserQuizQuestions
      answers={flow.answers}
      canContinueAnyway={flow.canContinueAnyway}
      currentStep={flow.currentStep}
      hasSubmitError={flow.hasSubmitError}
      isAdvancing={flow.isAdvancing}
      isSubmitting={flow.isSubmitting}
      localization={localization}
      onBack={flow.goBack}
      onContinueAnyway={flow.continueAnyway}
      onSelectPriority={flow.selectPriority}
      onSelectSingle={flow.selectSingleAnswer}
      onSubmit={flow.submit}
    />
  );
};
